(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/game-package/assets/react/hooks/use-week-draw-updates.js') >= 0) return;  svs.modules.push('/modules/game-package/assets/react/hooks/use-week-draw-updates.js');

'use strict';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const drawsOptions = svs.gamePackage.data.packageConfig.drawsOptions;
const _React = React,
  useEffect = _React.useEffect;
const _ReactRedux = ReactRedux,
  useDispatch = _ReactRedux.useDispatch;
const _svs$numbergames$draw = svs.numbergames.draws,
  DRAW_STATES = _svs$numbergames$draw.constants.DRAW_STATES,
  drawsApi = _svs$numbergames$draw.drawsApi,
  asyncDrawsApi = _svs$numbergames$draw.asyncDrawsApi,
  asyncJackpotApi = _svs$numbergames$draw.asyncJackpotApi;
const updateDraws = svs.gamePackage.redux.gamePackageSlice.actions.updateDraws;
const getPackageDraws = svs.gamePackage.mappers.getPackageDraws;
let outdatedTimeout;
let outdatedRetriesCount = 0;
function keepDrawsUpToDate(callback) {
  clearTimeout(outdatedTimeout);
  if (document.visibilityState === 'hidden') {
    return;
  }
  const draws = getPackageDraws().map(draw => _objectSpread(_objectSpread({}, draw), {}, {
    dateTime: new Date(draw.drawStateId === DRAW_STATES.DEFINED ? draw.regOpenTime : draw.regCloseTime)
  })).sort((a, b) => a.dateTime - b.dateTime);

  let clientTtl = 2000 + dateFns.differenceInMilliseconds(draws[0].dateTime, new Date(drawsApi.clientNow()));
  if (clientTtl > 0) {
    outdatedRetriesCount = 0;
  } else if (outdatedRetriesCount >= 5) {
    svs.gamePackage.logger.info("Automatic draw update prevented. Suspect client time is wrong: ".concat(drawsApi.clientNow()));
    return;
  } else {
    clientTtl = outdatedRetriesCount * 10000;
  }
  outdatedTimeout = setTimeout(async () => {
    outdatedRetriesCount++;
    await asyncDrawsApi.findDraw(drawsOptions);
    await asyncJackpotApi.jackpot(drawsOptions);
    callback();
    keepDrawsUpToDate(callback);
  }, clientTtl);
}
function useWeekDrawUpdates() {
  const dispatch = useDispatch();
  useEffect(() => {
    const keepUpToDate = () => keepDrawsUpToDate(() => dispatch(updateDraws(getPackageDraws())));
    document.addEventListener('visibilitychange', keepUpToDate);
    keepUpToDate();
    return () => document.removeEventListener('visibilitychange', keepUpToDate);
  }, [dispatch]);
  return null;
}
svs.gamePackage.hooks.useWeekDrawUpdates = useWeekDrawUpdates;

 })(window);